module.exports = __webpack_public_path__ + "img/44.af2b6617.webp";